import {
  IssueChangelogEntityType,
  OperationV2Dto,
  StageChangeOperationType,
} from 'shared/types/changelogV2';
import { OperationV1 } from 'views/issue/issueHistory/types';

export function isChangelogOperationV2(
  operation: OperationV1 | OperationV2Dto
): operation is OperationV2Dto {
  return operation.version === 2;
}

export function isStageChangeChangelogOperation(
  operation: OperationV1 | OperationV2Dto
): operation is OperationV2Dto {
  return (
    isChangelogOperationV2(operation) &&
    operation.entityType === IssueChangelogEntityType.stage &&
    (operation.operationType === StageChangeOperationType.stageChange ||
      operation.operationType ===
        StageChangeOperationType.stageChangedAutomatically) &&
    Boolean(operation.stageIdAfter)
  );
}
